import React from "react";
import { Input, notification } from "antd";
import classes from "./result-box.module.scss";
import copy from "copy-to-clipboard";
import classNames from "classnames";

const { TextArea } = Input;

const ResultBox = ({ data, boxClass, showCopyAll = true }) => {
  const onCopy = () => {
    copy(data);
    notification.success({
      message: "Copied!",
    });
  };

  const onCopyItem = (item) => {
    copy(item);
    notification.success({
      message: "Copied!",
    });
  };

  return (
    <div className={classNames(classes.BoxWrap, boxClass)}>
      <TextArea value={data} className={classes.TextArea} />

      {showCopyAll && (
        <div className={classes.CopyWrap}>
          <button
            className={classNames(classes.CopyItemIcon, "btn btn-primary")}
            onClick={onCopy}
          >
            Copy
          </button>
          {/*<Tooltip title="Copy All">*/}
          {/*  <FontAwesomeIcon*/}
          {/*    className={classNames(classes.CopyIcon, "text-primary")}*/}
          {/*    icon={faCopy}*/}
          {/*    onClick={onCopy}*/}
          {/*  />*/}
          {/*</Tooltip>*/}
        </div>
      )}
    </div>
  );
};

export default ResultBox;
